import { AlertNotif } from "components/Alert";

const formValidator = (data, type, isEdit, isDocument) => {
  let dataPayload = {}
  let errorData = []
  switch (type) {
    case 'pencipta':
      for (const pair of data.entries()) {
        dataPayload[pair[0]] = pair[1]
      }
      dataPayload.payload = JSON.parse(dataPayload.payload)

      const isKtp = isDocument.some(item => item.document_code === "KTP");
      const isNpwp = isDocument.some(item => item.document_code === "NPWP Perusahaan");

      if (!dataPayload.ktp) {
        if(!isKtp) errorData.push('Foto KTP')
      }
      if (!dataPayload.npwp) {
        if(!isNpwp) errorData.push('Foto NPWP')
      }
      if(!isEdit) {
        if (!dataPayload.email) errorData.push('Email')
      }
      for (let firstKey in dataPayload.payload) {
        for (let secondKey in dataPayload.payload[firstKey]) {
          const currentData = dataPayload.payload[firstKey][secondKey]
          if (secondKey === 'name' && !currentData) errorData.push('Nama Lengkap')
          if (secondKey === 'role' && !currentData) errorData.push('Registrasi Sebagai')
          if (secondKey === 'address' && !currentData) errorData.push('Alamat Rumah')
          if (secondKey === 'phone_number' && !currentData) errorData.push('Telpon')
          if (secondKey === 'place_of_birth' && !currentData) errorData.push('Tempat Lahir')
          if (secondKey === 'date_of_birth' && !currentData) errorData.push('Tanggal Lahir')
          if (secondKey === 'identity_number' && !currentData) errorData.push('No Identitas KTP')
          if (secondKey === 'npwp_number' && !currentData) errorData.push('No NPWP')
          if (secondKey === 'account_name' && !currentData) errorData.push('Atas Nama')
          if (secondKey === 'account_number' && !currentData) errorData.push('No Rekening')
          if (secondKey === 'bank' && !currentData) errorData.push('Nama Bank')
        }
      }

      if (errorData.length === 0) return true

      AlertNotif({
        icon: 'warning',
        title: `Data Tidak Lengkap`,
        html: errorHtml(errorData)
      })
      return false
    case 'ahli waris':
      for (const pair of data.entries()) {
        dataPayload[pair[0]] = pair[1]
      }
      dataPayload.payload = JSON.parse(dataPayload.payload)

      if (!dataPayload.ktp) errorData.push('Foto KTP')
      if (!dataPayload.npwp) errorData.push('Foto NPWP')
      if (!dataPayload.ahli_waris) errorData.push('Dokumen Penunjukan Ahli Waris')


      // console.log(dataPayload)
      for (let firstKey in dataPayload.payload) {
        for (let secondKey in dataPayload.payload[firstKey]) {
          const currentData = dataPayload.payload[firstKey][secondKey]
          if (secondKey === 'name' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'role' && !currentData) errorData.push('Registrasi Sebagai')
          if (secondKey === 'email' && !currentData) errorData.push('Email')
          if (secondKey === 'address' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'phone_number' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'place_of_birth' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'date_of_birth' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'identity_number' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'npwp_number' && !currentData) errorData.push(`${firstKey === 'pencipta' ? 'Nama Lengkap Songwriter' : 'Nama Ahli Waris'}`)
          if (secondKey === 'bank_data') {
            for (let thirdKey in dataPayload.payload[firstKey][secondKey]) {
              const dataBank = dataPayload.payload[firstKey][secondKey][thirdKey]
              if (thirdKey === 'account_name' && !currentData) errorData.push('Atas Nama')
              if (thirdKey === 'account_number' && !currentData) errorData.push('No Rekening')
              if (thirdKey === 'bank' && !currentData) errorData.push('Nama Bank')
            }
          }
        }
      }

      return false
    default:
      break;
  }
}

function errorHtml(data) {

  let errorAlert = `<ol>`
  data.forEach((val, index) => {
    if (index !== data.length - 1) {
      errorAlert += `<li style="width:fit-content; padding-left: 20px; margin-bottom: 10px">${val}</li>`
    } else {
      errorAlert += `<li style="width:fit-content; padding-left: 20px; margin-bottom: 10px">${val}</li></ol>`
    }
  })

  return errorAlert
}

export default formValidator